import React, { Component } from 'react';
import RequestedUser from '../RequestedUser';
import PropTypes from 'prop-types';
import './style.scss';

export default class RequestedUserList extends Component {
  render() {
    const { requestedUsers = [], eventId, openPopupChooseStudent, openPopupViewStudentProfile, isOfferEvent } = this.props;

    if (requestedUsers.length === 0) {
      return null;
    }

    const requestedUserIdList = requestedUsers.map(requestedUser => requestedUser.objectId);

    return (
      <div id="requested-user-list">
        <div id="title">応募者</div>
        {
          requestedUsers.map((user, index) => <RequestedUser
            key={user.objectId}
            requestedUser={user}
            openPopupChooseStudent={openPopupChooseStudent}
            openPopupViewStudentProfile={() => openPopupViewStudentProfile(index, requestedUserIdList, 'requested')}
            eventId={eventId}
            isOfferEvent={isOfferEvent}
          />)
        }
      </div>
    );
  }
}

RequestedUserList.propTypes = {
  requestedUsers: PropTypes.array,
  openPopupChooseStudent: PropTypes.func,
  openPopupViewStudentProfile: PropTypes.func,
  eventId: PropTypes.string,
  isOfferEvent: PropTypes.bool
};